import { React, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment';

import FetchModule from '../../../../Share/Network/FetchModule';

export default function LockerUsageStopModal(props) {
  const { data, lockerRendering, onClickExit } = props;

  const [usageDayText, setUsageDayText] = useState('');

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  // Init Data Setting //
  useEffect(() => {
    if (moment(data.endDate).format('YYYY.MM.DD') > moment().format('YYYY.MM.DD')) setUsageDayText('현재 ' + (moment(data.endDate).diff(moment(), 'days') + 1) + ' 일 남았습니다');
    else if (moment(data.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) setUsageDayText('금일 종료 예정입니다');
    else return setUsageDayText('현재 ' + (moment().diff(moment(data.endDate), 'days') + 1) + ' 일 초과 사용중입니다');
  }, [data])

  // 삭제 버튼 클릭시 //
  function deleteClick() {
    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.postData('locker/stop/' + data.lockerId, 'POST');

    //     if (responseData.status === 200) {
    //       alert('사용 종료가 완료되었습니다!');
    //       lockerRendering();
    //       onClickExit();
    //     }
    //     else if (responseData.status === 204) { }
    //   }
    // )();
    let requestData = {
      usageId: data.usageId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/stop/', 'POST', requestData);

        if (responseData.status === 200) {
          alert('사용 종료가 완료되었습니다!');
          lockerRendering();
          onClickExit();
        }
        else if (responseData.status === 204) { }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>락커 사용 종료</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>{data.lockerName + ' 락커를 사용 종료합니다'}</Text>
        </TitleWrapper>
        <TextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{'현재 ' + data.userName + ' 회원님이 사용중인 락커 사용을 종료할까요?'}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{usageDayText}</Text>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='pointer'>취소</Text>
          </ExitButton>
          <CancelButton onClick={deleteClick}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>종료하기</Text>
          </CancelButton>
        </ButtonWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 20px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 4px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;
  
  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #FF3131;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
